<div class="row">
    <div class="col-md-2"></div>
    <div class="col-sm-12 col-md-8">
        <h4 dir="rtl" class="text-center" [class]="season.className">תקופת {{season.name}} שנת {{season.hebrewDate.years}}</h4>
    </div>
</div>

<app-heb-units [hebrewDate]="season" [latitudeTotimezone]="latitude"></app-heb-units>
<app-planet-effect [season]="season"></app-planet-effect>
